/* eslint-disable no-nested-ternary */
import {
  Box,
  BoxProps,
  Button,
  CircularProgress,
  Divider,
  Typography
} from '@material-ui/core';
import React from 'react';
import { Virtuoso } from 'react-virtuoso';

import { DistrictListing } from '../../../../services/APIService';
import DistrictResult from './DistrictResult';

export interface ListPanelProps {
  results?: DistrictListing[];
  isLoading: boolean;
  onOpenFilters?: () => void;
  onSelect: (districtId: string) => void;
}

const ListPanel: React.FC<ListPanelProps & Pick<BoxProps, 'flex'>> = ({
  results = [],
  isLoading,
  onOpenFilters,
  onSelect,
  ...rootProps
}) => {
  return (
    <Box {...rootProps} display="flex" flexDirection="column">
      <Box>
        <Box
          px={2}
          py={2}
          display="flex"
          flexDirection={{ xs: 'column', sm: 'row' }}
          alignItems="flex-start"
        >
          <Box mx={1} flex="1 1 auto">
            <Typography variant="h4">
              {results.length.toLocaleString()} District
              {results.length !== 1 && 's'}
            </Typography>
          </Box>
          {onOpenFilters && (
            <Box
              flex="0 0 auto"
              mt={{ xs: 1, sm: 0 }}
              display="flex"
              flexDirection="row"
            >
              <Button
                variant="text"
                color="primary"
                onClick={() => onOpenFilters()}
              >
                Filters
              </Button>
            </Box>
          )}
        </Box>

        <Divider />
      </Box>
      {results.length > 0 ? (
        <Box flex="1">
          <Virtuoso
            style={{ height: '100%' }}
            data={results}
            itemContent={(index, result) => (
              <Box
                pt={index === 0 ? 2 : 1}
                pb={index === results.length - 1 ? 2 : 1}
                px={2}
              >
                <DistrictResult
                  result={result}
                  onSelect={() => onSelect(result.districtId)}
                />
              </Box>
            )}
          />
        </Box>
      ) : isLoading ? (
        <Box display="flex" justifyContent="center" pt={5}>
          <CircularProgress size={20} />
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" pt={3}>
          <Typography color="textSecondary">No Matching Districts</Typography>
        </Box>
      )}
    </Box>
  );
};

export default ListPanel;
